module.exports = __webpack_public_path__ + "static/media/noEvents_image.89d401bf.svg";